export enum StripeStatus {
  Initial = 'initial',
  Pending = 'pending',
  Error = 'error',
  Complete = 'complete',
}
